import { render } from "./NewNavbar.vue?vue&type=template&id=0e23812c&scoped=true"
import script from "./NewNavbar.vue?vue&type=script&lang=js"
export * from "./NewNavbar.vue?vue&type=script&lang=js"

import "./NewNavbar.vue?vue&type=style&index=0&id=0e23812c&scoped=true&lang=css"

import exportComponent from "/var/www/zaytoon-frontend-base/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e23812c"]])

export default __exports__